import React from 'react';
import isEmpty from 'lodash/isEmpty';

import { CREDENTIAL_TYPE_LIST, CREDENTIAL_TYPE } from 'app/constants/profile';
import { generateCredentialText } from 'app/utils/formatCredentials';
import ProfileCredentialIcon from 'app/components/profile/ProfileCredentialIcon';

const ProfileCredential = props => {
  const { name, description, latestCredential, links } = props;
  const shouldRenderEmptyProfileState = isEmpty(description) && isEmpty(links);
  const shouldRenderEmptyCredentialState =
    isEmpty(latestCredential[CREDENTIAL_TYPE.EMPLOYMENT]) &&
    isEmpty(latestCredential[CREDENTIAL_TYPE.EDUCATION]);

  return (
    <div className="card h-fit">
      <div className="mobile-only mb-6">
        <p className="font-bold text-base">About</p>
        {shouldRenderEmptyProfileState && (
          <p className="text-neutral-500">{`${name}'s profile is not filled up yet.`}</p>
        )}
        <p>{description}</p>
      </div>
      <div className="flex flex-col gap-2 w-full">
        <p className="font-bold text-base">Credentials</p>
        {shouldRenderEmptyCredentialState && (
          <p className="text-neutral-500">{`${name}'s credentials are not filled up yet.`}</p>
        )}
        {!shouldRenderEmptyCredentialState && (
          <div className="flex flex-col gap-4 w-full">
            {CREDENTIAL_TYPE_LIST.map(credentialType => {
              const credential = latestCredential[credentialType];
              if (isEmpty(credential)) {
                return null;
              }

              return (
                <div
                  className="flex items-center lg:block text-neutral-700"
                  key={credentialType}
                >
                  <ProfileCredentialIcon credentialType={credentialType} />
                  <p className="text-neutral-500 break-words inline-block">
                    {generateCredentialText(credential)}
                  </p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileCredential;
